export interface CatalogoOpciones {
  id:  number,
  tipoDeValor: string,
  descripcion: string
};
